export const SLA_FIELD_ISSUE_TYPE = 'issueType';
export const SLA_FIELD_ISSUE_SUBTYPE = 'issueSubtype';
export const SLA_FIELD_ISSUE_SEVERITY = 'severity';
export const SLA_FIELD_DAYS = 'slaDays';
export const SLA_FIELD_MAX_ISSUE_DUE_DATE = 'maxDueDate';
export const SLA_FIELD_ESCALATION = 'escalationDays';
export const SLA_FIELD_REMINDER = 'reminderDays';

export type SLAFieldNameType =
  | typeof SLA_FIELD_ISSUE_TYPE
  | typeof SLA_FIELD_ISSUE_SUBTYPE
  | typeof SLA_FIELD_ISSUE_SEVERITY
  | typeof SLA_FIELD_DAYS
  | typeof SLA_FIELD_MAX_ISSUE_DUE_DATE
  | typeof SLA_FIELD_ESCALATION
  | typeof SLA_FIELD_REMINDER;

export const SLAS_GRID_KEY = 'SLAs-grid';
